import { isMobileDevice } from "./deviceProfile";
let audio;
let lastPlayed = 0;
const pushShown = new Set();
if ("serviceWorker" in navigator) navigator.serviceWorker.addEventListener("message", (e) => {
  if (e.data?.type === "PUSH_SHOWN") { pushShown.add(e.data.notification_id); if (pushShown.size > 200) pushShown.delete(pushShown.values().next().value); }
});
export const armSound = () => {
  if (!isMobileDevice()) return;
  try { audio ||= new (window.AudioContext || window.webkitAudioContext)(); audio.resume().catch(() => {}); } catch {}
};
export const playChime = (notificationId) => {
  if (!isMobileDevice() || localStorage.getItem("gsp_mobile_notification_sound") === "off" || document.hidden || Date.now() - lastPlayed < 2000 || (notificationId && pushShown.has(notificationId))) return;
  if (!audio || audio.state !== "running") return;
  lastPlayed = Date.now();
  [659.25, 880, 1318.51].forEach((frequency, i) => {
    const oscillator = audio.createOscillator(), gain = audio.createGain(), at = audio.currentTime + i * 0.13;
    oscillator.type = "sine"; oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0, at); gain.gain.linearRampToValueAtTime(0.13, at + 0.02); gain.gain.exponentialRampToValueAtTime(0.001, at + 0.4);
    oscillator.connect(gain); gain.connect(audio.destination); oscillator.start(at); oscillator.stop(at + 0.42);
  });
};